import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { EhrResyncResponse } from '@vagusx/clients';
import { getAppointmentClient } from '@/lib/api-clients';
import { queryKeys } from '@/lib/query-keys';

/**
 * Retry an appointment's EHR write (ADR-284). The API only queues it; the
 * reconcile worker makes the EHR call a few seconds later, so the lists and the
 * detail sheet poll while the row shows "Syncing" (`syncingRefetchInterval`).
 * Errors toast through the global MutationCache handler.
 */
export function useAppointmentEhrResync(): UseMutationResult<EhrResyncResponse, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => getAppointmentClient().requestEhrResync(id),
    onSuccess: () => {
      toast.success('Sending to the EHR again');
      queryClient.invalidateQueries({ queryKey: queryKeys.appointments.all });
    },
  });
}
